import apercuRegularEOT from './apercu-regular.eot'
import apercuRegularTTF from './apercu-regular.ttf'
import apercuRegularWOFF from './apercu-regular.woff'
import apercuRegularWOFF2 from './apercu-regular.woff2'

import apercuMediumEOT from './apercu-medium.eot'
import apercuMediumTTF from './apercu-medium.ttf'
import apercuMediumWOFF from './apercu-medium.woff'
import apercuMediumWOFF2 from './apercu-medium.woff2'

//import apercuBoldEOT from './apercu-bold.eot'
import apercuBoldTTF from './apercu-bold.ttf'
import apercuBoldWOFF from './apercu-bold.woff'
import apercuBoldWOFF2 from './apercu-bold.woff2'

export default {
  apercuRegularTTF,
  apercuRegularEOT,
  apercuRegularWOFF,
  apercuRegularWOFF2,

  apercuMediumEOT,
  apercuMediumTTF,
  apercuMediumWOFF,
  apercuMediumWOFF2,

  //apercuBoldEOT,
  apercuBoldTTF,
  apercuBoldWOFF,
  apercuBoldWOFF2,
}
